var _style, _polygon, _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommuneArbre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Commune",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.stcomma0{fill:#605F71;}\r\n\t.stcomma1{fill:none;stroke:#605F71;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.stcomma2{fill:#FFFFFF;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "stcomma0",
    points: "8.5,3.3 4.2,6.3 12.9,6.3 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "stcomma1",
    x1: 8.6,
    y1: 1.3,
    x2: 8.6,
    y2: 4.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    className: "stcomma0",
    width: 3.1,
    height: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "stcomma0",
    width: 4.3,
    height: 17
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 5.7,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 2.2,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 12.9,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 9.3,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.9,
    y: 6.7,
    className: "stcomma0",
    width: 9.3,
    height: 10.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 12.8,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 9.3,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9,
    className: "stcomma0",
    width: 4.1,
    height: 17
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 5.7,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 2.2,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 12.9,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1,
    y: 9.3,
    className: "stcomma2",
    width: 1.7,
    height: 1.7
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    y: 16.5,
    className: "stcomma2",
    width: 17,
    height: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommuneArbre);
export default __webpack_public_path__ + "static/media/Commune-arbre.180e0baf0afc34a07afff1067f70ae25.svg";
export { ForwardRef as ReactComponent };